import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { getClients } from "api/resources/clients";

export interface ClientOption {
  title: string;
  value: number;
}

interface ReportClientSelectProps {
  selectedClient: ClientOption | null;
  setSelectedClient: (client: ClientOption | null) => void;
  groupClients: ClientOption[] | null;
}

const ReportClientSelect: React.FC<ReportClientSelectProps> = ({
  selectedClient,
  setSelectedClient,
  groupClients,
}) => {
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState<ClientOption[]>([]);

  useEffect(() => {
    if (groupClients || !query) {
      return;
    }
    const delay = setTimeout(() => {
      getClients(0, 15, null, query).then((result) => {
        setSearchResults(
          result?.data.content.map((c) => ({
            title:
              c.type === "BUSINESS"
                ? c.companyName
                : c.firstName + " " + c.lastName,
            value: c.id,
          })) ?? [],
        );
      });
    }, 300);
    return () => clearTimeout(delay);
  }, [query, groupClients]);

  return (
    <Autocomplete
      size="small"
      sx={{ width: 260, background: "white" }}
      value={selectedClient}
      options={groupClients ?? searchResults}
      getOptionLabel={(option) => option.title}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(_event, value) => setSelectedClient(value)}
      onInputChange={(_event, value, reason) => {
        if (reason === "input") {
          setQuery(value);
        }
      }}
      filterOptions={groupClients ? undefined : (options) => options}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          {option.title}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Client"
          placeholder={groupClients ? "" : "Search"}
        />
      )}
    />
  );
};

export default ReportClientSelect;
